import { UrlHelper } from "../core/html/url-helper";
import { Logger } from "../logger/logger";
import { ServiceProvider } from "../core/provider/service-provider";

export abstract class DllNameTemplate {
	public static checkIfDllExists = async (dllName: string) => {
		if (!dllName) {
			return false;
		}

		let params = {
			dllName
		};
		let result = await ServiceProvider.ajax.getJsonNoCacheAsync({ url: UrlHelper.getDataUrl("dllexists"), params }).catch((err) => {
			Logger.error(`Error while checking if dll '${dllName}' exists`, err);
			return false;
		});
		if (result) {
			return true;
		} else {
			return false;
		}
	}
}